export default __webpack_public_path__ + "static/media/active_price.1fe6c9ed.svg";